import {
  BookOpenText,
  ChevronDown,
  ExternalLink,
  Files,
  FileText,
  Landmark,
  Scale,
} from "lucide-react";
import { CopyableDate } from "@tribunalea/ui";
import {
  citationTypeLabel,
  normalizeCitation,
  safeSourceUrl,
} from "./sources.js";

const typeIcons = {
  legislation: Landmark,
  doctrine: BookOpenText,
  jurisprudence: Scale,
  case_record: Files,
  attachment: FileText,
  library: Files,
};

const dateFormatter = new Intl.DateTimeFormat("es-AR", {
  dateStyle: "medium",
});

function formatDate(value) {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : dateFormatter.format(date);
}

export function CitationCard({ citation: rawCitation, index }) {
  const citation = normalizeCitation(rawCitation);
  const Icon = typeIcons[citation.type] || BookOpenText;
  const sourceUrl = safeSourceUrl(citation.source?.url);
  const validFrom = formatDate(citation.metadata?.validFrom);
  const validTo = formatDate(citation.metadata?.validTo);
  const organization =
    citation.source?.organization || citation.source?.title || null;

  return (
    <details className={`justiniano-citation is-${citation.type}`}>
      <summary>
        <span className="justiniano-citation-number">{index + 1}</span>
        <span className="justiniano-citation-heading">
          <span>
            <Icon size={12} />
            {citationTypeLabel(citation.type)}
            {(citation.source?.official || citation.metadata?.official) && (
              <em>Oficial</em>
            )}
          </span>
          <strong>{citation.label}</strong>
        </span>
        <ChevronDown className="justiniano-citation-chevron" size={15} />
      </summary>
      <div className="justiniano-citation-body">
        {citation.metadata?.fixture && (
          <div className="justiniano-citation-fixture">
            Fuente ficticia de demostración
          </div>
        )}
        {citation.quoteText && <blockquote>{citation.quoteText}</blockquote>}
        <div className="justiniano-citation-meta">
          {organization && <span>{organization}</span>}
          {citation.locator && citation.locator !== citation.label && (
            <span>{citation.locator}</span>
          )}
          {validFrom && (
            <span>
              Vigente desde{" "}
              <CopyableDate value={citation.metadata.validFrom}>
                {validFrom}
              </CopyableDate>
            </span>
          )}
          {validTo && (
            <span>
              Vigente hasta{" "}
              <CopyableDate value={citation.metadata.validTo}>
                {validTo}
              </CopyableDate>
            </span>
          )}
        </div>
        {sourceUrl && (
          <a href={sourceUrl} target="_blank" rel="noreferrer">
            Ver fuente original <ExternalLink size={12} />
          </a>
        )}
      </div>
    </details>
  );
}
